import { Reveal } from "./Reveal";
import { Building2, Cog, TrendingUp, ChevronRight } from "lucide-react";

const pillars = [
  {
    icon: Building2,
    title: "You Own The Company",
    text: "Your business. Your carrier. Your revenue.",
  },
  {
    icon: Cog,
    title: "We Manage The Operations",
    text: "The systems and day-to-day operating infrastructure needed to keep the business moving.",
  },
  {
    icon: TrendingUp,
    title: "You Build An Asset",
    text: "Start with one truck and build a transportation company that can grow.",
  },
];

export const PainPoints = () => {
  return (
    <section id="own" data-testid="ownership-section" className="bg-[#050505] py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <Reveal>
          <p className="font-display text-sm font-semibold uppercase tracking-[0.3em] text-orange-500 mb-6" data-testid="ownership-eyebrow">
            The Ownership Model
          </p>
          <h2
            className="font-display text-4xl md:text-5xl font-bold uppercase tracking-tight leading-[1.05] text-white max-w-4xl"
            data-testid="ownership-headline"
          >
            You Don't Have To Drive The Truck.
            <span className="block text-orange-500">You Have To Own The Business.</span>
          </h2>
        </Reveal>

        <div className="mt-12 grid md:grid-cols-2 gap-12 md:gap-16 items-start">
          <Reveal>
            <div className="space-y-5 text-base md:text-lg text-neutral-300" data-testid="ownership-body">
              <p>Most people think getting into trucking means becoming a truck driver.</p>
              <p className="text-white font-semibold">It doesn't.</p>
              <p>
                Trucking is an operating business with equipment, customers, drivers, compliance,
                dispatch, financial management and logistics working together.
              </p>
              <p>
                I Stay Trucking was built for entrepreneurs who want to own the company without
                having to personally manage every moving part.
              </p>
            </div>
            <a
              href="#services"
              data-testid="ownership-cta"
              className="mt-10 inline-flex items-center gap-2 bg-orange-500 px-8 py-5 font-display text-base md:text-lg font-semibold uppercase tracking-wider text-white transition-all duration-200 hover:bg-orange-600 hover:-translate-y-1"
            >
              Explore Ownership
              <ChevronRight size={20} />
            </a>
          </Reveal>

          <div className="flex flex-col gap-4">
            {pillars.map((p, i) => (
              <Reveal key={p.title} delay={0.1 * i}>
                <div
                  data-testid={`ownership-pillar-${i}`}
                  className="group flex gap-6 border border-neutral-800 bg-[#121212] p-8 transition-all duration-200 hover:-translate-y-1 hover:border-orange-500/70"
                >
                  <p.icon size={34} className="shrink-0 text-orange-500" strokeWidth={1.75} />
                  <div>
                    <h3 className="font-display text-xl md:text-2xl font-bold uppercase tracking-tight text-white">
                      {p.title}
                    </h3>
                    <p className="mt-2 text-sm md:text-base text-neutral-400">{p.text}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
